import React, { useState, useEffect } from "react";
import styles from "./bubbles-list.styles.css";
import IndividualFeatureBubble from "./feature-bubble.component.js";
import { CpButton } from "@canopytax/understory";

export default function BubblesList(props) {
  const { bubbles, close } = props;
  const [navHeight, setHeight] = useState(0);
  useEffect(() => {
    let subscription;
    Promise.all([
      SystemJS.import("primary-navbar!sofe"),
      SystemJS.import("rxjs/operators"),
    ]).then(([nav]) => {
      subscription = nav.primaryNavHeightObs.subscribe((newNavHeight) => {
        setHeight(newNavHeight);
      });
    });
    return () => {
      subscription && subscription.unsubscribe();
    };
  }, []);

  return (
    <div
      className={`${styles.bubblesList} cps-card__height-3`}
      style={{
        maxHeight: `calc(100vh - ${navHeight}px - ${32}px /* icon */ - ${16}px /* icon padding */ - ${8}px /* top padding */)`,
      }}
    >
      <div className={styles.closeIcon}>
        <CpButton icon="close-small" aria-label="close" onClick={close} />
      </div>
      {[...bubbles]
        .sort((a, b) => b?.expirationDate.localeCompare(a?.expirationDate))
        .map((bubble, index) => {
          return (
            <IndividualFeatureBubble
              key={bubble.toggle}
              bubble={bubble}
              close={close}
              bottomHR={index !== bubbles.length - 1}
            />
          );
        })}
    </div>
  );
}
